import has from 'lodash/has';
import {
  GET_PRODUKTE,
  GET_PRODUKTBYID,
  CREATE_PRODUKT,
  CHECK_PRODUKTE,
  DELETE_PRODUKT,
  UPDATE_PRODUKT,
  GET_PRODUKTE_NAMES,
  CHECK_PRODUKT_REFERENCES,
  GET_PRODUKT_HISTORY,
  GET_PRODUKT_VERSION,
  RESTORE_PRODUKT_VERSION,
  COMPARE_PRODUKT_VERSIONS,
  RESET_PRODUKT_HISTORY,
} from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

export function produkte(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PRODUKTE}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_PRODUKTE}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result')
          ? { ...action.result }
          : { produkte: [], total_pages: 0 },
      };
    case `${GET_PRODUKTE}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function produkteNames(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PRODUKTE_NAMES}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_PRODUKTE_NAMES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? [...action.result] : [],
      };
    case `${GET_PRODUKTE_NAMES}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function produkteCheck(state = initialState, action = {}) {
  switch (action.type) {
    case `${CHECK_PRODUKTE}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${CHECK_PRODUKTE}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : '',
      };
    case `${CHECK_PRODUKTE}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

export function produktByID(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PRODUKTBYID}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_PRODUKTBYID}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${GET_PRODUKTBYID}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: {},
      };
    default:
      return state;
  }
}

export function produktCreate(state = initialState, action = {}) {
  switch (action.type) {
    case `${CREATE_PRODUKT}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${CREATE_PRODUKT}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${CREATE_PRODUKT}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}

export function produktDelete(state = initialState, action = {}) {
  switch (action.type) {
    case `${DELETE_PRODUKT}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${DELETE_PRODUKT}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${DELETE_PRODUKT}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}

export function produktUpdate(state = initialState, action = {}) {
  switch (action.type) {
    case `${UPDATE_PRODUKT}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${UPDATE_PRODUKT}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? { ...action.result } : {},
      };
    case `${UPDATE_PRODUKT}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}

export function produktCheckReferences(state = initialState, action = {}) {
  switch (action.type) {
    case `${CHECK_PRODUKT_REFERENCES}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${CHECK_PRODUKT_REFERENCES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : '',
      };
    case `${CHECK_PRODUKT_REFERENCES}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
}

const historyInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: {
    history: [],
    total: 0,
    entity_id: null,
  },
};

export function produktHistory(state = historyInitialState, action = {}) {
  switch (action.type) {
    case `${GET_PRODUKT_HISTORY}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_PRODUKT_HISTORY}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result')
          ? {
              history: action.result.history || [],
              total: action.result.total || 0,
              entity_id: action.result.entity_id,
            }
          : historyInitialState.data,
      };
    case `${GET_PRODUKT_HISTORY}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: historyInitialState.data,
      };
    case RESET_PRODUKT_HISTORY:
      return historyInitialState;
    default:
      return state;
  }
}

const versionInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: null,
};

export function produktVersion(state = versionInitialState, action = {}) {
  switch (action.type) {
    case `${GET_PRODUKT_VERSION}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_PRODUKT_VERSION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result.version : null,
      };
    case `${GET_PRODUKT_VERSION}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: null,
      };
    case RESET_PRODUKT_HISTORY:
      return versionInitialState;
    default:
      return state;
  }
}

const restoreInitialState = {
  error: null,
  loaded: false,
  loading: false,
  success: false,
  data: null,
};

export function produktRestore(state = restoreInitialState, action = {}) {
  switch (action.type) {
    case `${RESTORE_PRODUKT_VERSION}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
        success: false,
      };
    case `${RESTORE_PRODUKT_VERSION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        success: true,
        data: has(action, 'result') ? action.result : null,
      };
    case `${RESTORE_PRODUKT_VERSION}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        success: false,
        data: null,
      };
    case RESET_PRODUKT_HISTORY:
      return restoreInitialState;
    default:
      return state;
  }
}

const compareInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: null,
};

export function produktCompare(state = compareInitialState, action = {}) {
  switch (action.type) {
    case `${COMPARE_PRODUKT_VERSIONS}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${COMPARE_PRODUKT_VERSIONS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: has(action, 'result') ? action.result : null,
      };
    case `${COMPARE_PRODUKT_VERSIONS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: null,
      };
    case RESET_PRODUKT_HISTORY:
      return compareInitialState;
    default:
      return state;
  }
}
